//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'

import WorkShift from './WorkShift.vue'

export default {
  components: {
    WorkShift
  },
  props: {
    workShifts: {
      type: Array,
      default () {
        return []
      }
    },
    workShiftSettings: {
      type: Object,
      default () {
        return {}
      }
    },
    dayoff: {
      type: Boolean,
      default: false
    },
    date: {
      type: Number,
      default: null
    },
    overtimeTariffs: {
      type: Array,
      default () {
        return []
      }
    },
    additionalWorkShifts: {
      type: Array,
      default () {
        return []
      }
    },
    additionalOvertimeTariffs: {
      type: Array,
      default () {
        return []
      }
    },
    getPreviousWorkShift: {
      type: Function,
      default: () => {}
    },
    autoAssignToBrigadeDefault: {
      type: Boolean,
      default: false
    },
    isLastWorkShift: {
      type: Boolean,
      default: false
    },
    office: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loading: false,

      additionalStatus: null,
      additionalStatuses: [],

      absences: [],

      autoAssignToBrigade: null,
      canPerformRequests: null,
      isOfficeAllowed: null,
      isDepartureAllowed: null,

      redirectedWorkArea: [],
      redirected: false,

      overtimeAfter: null,
      overtimeTariffAfterId: null,
      overtimeBefore: null,
      overtimeTariffBeforeId: null,
      overtimeTariffComment: null,

      additionalOvertimeTariffId: null,

      isOvertimeWorkShift: false,
      overtimeWorkShiftTariffId: null,

      planDayStatus: null,
      planDayHours: null,
      factDayStatus: null,
      factDayHours: null,

      drivingHours: 0,
      isDenyDrivingHoursCalc: false,

      additionalOvertimeTariffsFiltered: [],
      overtimeTariffsFiltered: [],

      selectWorkShift: {
        name: null,
        key: null,
        start: null,
        startHour: null,
        endHour: null,
        end: null,
        date: null
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    canAutofill: function () {
      if (this.redirected || !this.date || this.date < new Date().getTime() - 1000 * 60 * 60 * 24) {
        return false
      }
      return true
    },
    readonly: function () {
      return !this.$d_hasOperation('changeEmployeeSchedule')
    },
    prevWorkShift: function () {
      if (this.prevWorkShiftSettings) {
        return this.prevWorkShiftSettings.workShift
      } else if (this.isAdditional && this.day && this.day.workShift) {
        return this.day.workShift
      }
      return null
    },
    displayOvertimeBefore: function () {
      return !this.workShiftSettings.isAdditional
    },
    displayOvertimeAfter: function () {
      if (!this.workShiftSettings.isAdditional) {
        return !this.additionalWorkShifts || this.additionalWorkShifts.length === 0
      } else {
        return this.isLastWorkShift
      }
    }
  },
  watch: {
    additionalStatus: function (val) {
      if (val === 'illness' || val === 'another') {
        this.setAbsenceForAllDay(val)
      } else {
        this.absences = []
      }
    },
    overtimeBefore: function (val) {
      if (val == null || +val === 0) {
        this.overtimeTariffBeforeId = null
      } else {
        const defaultTariff = this.overtimeTariffsFiltered.find(tariff => tariff.isDefault)
        if (this.overtimeTariffBeforeId == null) {
          if (defaultTariff) {
            this.overtimeTariffBeforeId = defaultTariff.id
          }
        }
      }
    },
    overtimeTariffBeforeId: function (val) {
      if (!val) {
        this.overtimeBefore = null
      }
      this.emitOvertimesChange()
    },
    overtimeAfter: function (val) {
      if (val == null || +val === 0) {
        this.overtimeTariffAfterId = null
      } else {
        const defaultTariff = this.overtimeTariffsFiltered.find(tariff => tariff.isDefault)
        if (this.overtimeTariffAfterId == null) {
          if (defaultTariff) {
            this.overtimeTariffAfterId = defaultTariff.id
          }
        }
      }
    },
    overtimeTariffAfterId: function (val) {
      if (!val) {
        this.overtimeAfter = null
      }
      this.emitOvertimesChange()
    },
    overtimeWorkShiftTariffId: function (val) {
      this.emitOvertimesChange()
    },
    autoAssignToBrigade: function () {
      if (!this.workShiftSettings.isAdditional) {
        this.workShiftSettings.autoAssignToBrigade = this.autoAssignToBrigade
      }
    },
    selectWorkShift: {
      handler: function () {
        if (this.selectWorkShift && this.selectWorkShift.key) {
          this.workShiftSettings.workShift = this.selectWorkShift.key
          this.workShiftSettings.date = this.selectWorkShift.date
        }

        const selectWorkShift = this.workShifts.find(workShift => workShift.key === this.selectWorkShift.key)

        const wsType = selectWorkShift && selectWorkShift.wsType || null

        this.overtimeTariffsFiltered = this.overtimeTariffs.filter(tariff => tariff.workShiftType === 'all' || tariff.workShiftType === wsType)
        if (!this.overtimeTariffsFiltered.find(tariff => tariff.id === this.overtimeTariffBeforeId)) {
          this.overtimeTariffBeforeId = null
        }
        if (!this.overtimeTariffsFiltered.find(tariff => tariff.id === this.overtimeTariffAfterId)) {
          this.overtimeTariffAfterId = null
        }
        if (!this.overtimeTariffsFiltered.find(tariff => tariff.id === this.overtimeWorkShiftTariffId)) {
          this.overtimeWorkShiftTariffId = null
        }

        if (this.workShiftSettings.isAdditional) {
          this.additionalOvertimeTariffsFiltered = this.additionalOvertimeTariffs.filter(tariff => tariff.workShiftType === 'all' || tariff.workShiftType === wsType)
          if (!this.additionalOvertimeTariffsFiltered.find(tariff => tariff.id === this.additionalOvertimeTariffId)) {
            this.additionalOvertimeTariffId = null
          }
        }
      },
      immediate: true,
      deep: true
    },
    displayOvertimeBefore: function (val) {
      if (!val) {
        this.overtimeBefore = null
        this.overtimeTariffBeforeId = null
      }
    },
    displayOvertimeAfter: function (val) {
      if (!val) {
        this.overtimeAfter = null
        this.overtimeTariffAfterId = null
      }
    },
    dayoff: {
      handler: function () {
        if (this.dayoff && !this.workShiftSettings.isAdditional) {
          this.autoAssignToBrigade = false
          this.canPerformRequests = false
          this.isDepartureAllowed = false
          this.isOfficeAllowed = false

          this.additionalStatuses = [
            { label: 'Отпуск', value: 'vacation' },
            { label: 'Больничный', value: 'illness' },
            { label: 'Мобилизован', value: 'mobilized' },
            { label: 'Не допущен', value: 'notAllowed' }
          ]

          if (!this.additionalStatuses.map(status => status.value).includes(this.additionalStatus)) {
            this.additionalStatus = null
            this.absences = []
          }

          this.onSelectWorkShift(null)
        } else {
          this.additionalStatuses = [
            { label: 'Отпуск', value: 'vacation' },
            { label: 'Отгул', value: 'compensatoryHoliday' },
            { label: 'Больничный', value: 'illness' },
            { label: 'Командировка', value: 'mission' },
            { label: 'Удалёнка', value: 'remote' },
            { label: 'Подмена', value: 'replacement' },
            { label: 'Отработка', value: 'workoff' },
            { label: 'Мобилизован', value: 'mobilized' },
            { label: 'Отсутствие без причины', value: 'another' },
            { label: 'Не допущен', value: 'notAllowed' },
            { label: 'Отстранён', value: 'suspended' }
          ]

          this.autoAssignToBrigade = false
          this.canPerformRequests = true
          this.isDepartureAllowed = true
          this.isOfficeAllowed = true

          if (!this.selectWorkShift || !this.selectWorkShift.key) {
            const selectWorkShift = this.workShifts.find(workShift => workShift.key === 'brigadier.7-19')
            this.onSelectWorkShift(selectWorkShift)
          }
        }
      },
      immediate: true
    }
  },
  created: function () {
    this.prepareProperties(this.workShiftSettings)
  },
  methods: {
    prepareProperties: function (day) {
      if (day.absent) {
        this.absences = JSON.parse(JSON.stringify(day.absent))
      }

      if (day.vacation) {
        this.additionalStatus = 'vacation'
      } else if (day.mission) {
        this.additionalStatus = 'mission'
      } else if (day.notAllowed) {
        this.additionalStatus = 'notAllowed'
      } else if (day.suspended) {
        this.additionalStatus = 'suspended'
      } else if (day.remote) {
        this.additionalStatus = 'remote'
      } else if (day.replacement) {
        this.additionalStatus = 'replacement'
      } else if (day.workoff) {
        this.additionalStatus = 'workoff'
      } else if (day.mobilized) {
        this.additionalStatus = 'mobilized'
      } else if (day.compensatoryHoliday) {
        this.additionalStatus = 'compensatoryHoliday'
      } else if (this.isAbsenceAllDay(day.absent, 'illness')) {
        this.additionalStatus = 'illness'
      } else if (this.isAbsenceAllDay(day.absent, 'another')) {
        this.additionalStatus = 'another'
      } else {
        this.additionalStatus = null
      }

      if (!this.dayoff) {
        this.autoAssignToBrigade = day.autoAssignToBrigade || this.autoAssignToBrigadeDefault || false
      } else {
        this.autoAssignToBrigade = false
      }

      this.overtimeBefore = day.overtimeBefore
      this.overtimeAfter = day.overtimeAfter
      this.overtimeTariffBeforeId = day.overtimeTariffBeforeId
      this.overtimeTariffAfterId = day.overtimeTariffAfterId

      if (day.isAdditional) {
        this.additionalOvertimeTariffId = day.additionalOvertimeTariffId

        if (this.additionalOvertimeTariffId == null) {
          const defaultTariff = this.additionalOvertimeTariffsFiltered.find(tariff => tariff.isDefault)
          if (defaultTariff) {
            this.additionalOvertimeTariffId = defaultTariff.id
          }
        }
      }
      this.overtimeTariffComment = day.overtimeTariffComment
      this.isOvertimeWorkShift = day.overtimeWorkShiftTariffId != null
      this.overtimeWorkShiftTariffId = day.overtimeWorkShiftTariffId

      if (day.workShift) {
        const regularWorkShift = this.workShifts.find(workShift => workShift.key === day.workShift)
        if (regularWorkShift) {
          this.onSelectWorkShift(regularWorkShift)
        } else if (day.startHour && day.endHour) {
          const selectWorkShift = this.workShifts.find(workShift => workShift.key === 'brigadier.custom')
          selectWorkShift.startHour = day.startHour
          selectWorkShift.endHour = day.endHour
          this.onSelectWorkShift(selectWorkShift)
        }
      } else {
        this.onSelectWorkShift(null)
      }

      this.redirectedWorkArea = day.redirectedWorkArea

      this.planDayStatus = day.planDayStatus
      this.planDayHours = day.planDayHours
      this.factDayStatus = day.factDayStatus
      this.factDayHours = day.factDayHours

      if (day.drivingHours) {
        this.drivingHours = day.drivingHours
      }

      this.isDenyDrivingHoursCalc = !!day.isDenyDrivingHoursCalc
    },
    prepareWorkShiftSettingsToSave: function (workShiftSettingsToSave) {
      workShiftSettingsToSave.compensatoryHoliday = this.additionalStatus === 'compensatoryHoliday'
      workShiftSettingsToSave.vacation = this.additionalStatus === 'vacation'
      workShiftSettingsToSave.mobilized = this.additionalStatus === 'mobilized'
      workShiftSettingsToSave.mission = this.additionalStatus === 'mission'
      workShiftSettingsToSave.workoff = this.additionalStatus === 'workoff'
      workShiftSettingsToSave.replacement = this.additionalStatus === 'replacement'
      workShiftSettingsToSave.suspended = this.additionalStatus === 'suspended'
      workShiftSettingsToSave.remote = this.additionalStatus === 'remote'
      workShiftSettingsToSave.notAllowed = this.additionalStatus === 'notAllowed'

      workShiftSettingsToSave.autoAssignToBrigade = this.autoAssignToBrigade
      workShiftSettingsToSave.canPerformRequests = this.canPerformRequests
      workShiftSettingsToSave.isOfficeAllowed = this.isOfficeAllowed
      workShiftSettingsToSave.isDepartureAllowed = this.isDepartureAllowed
      workShiftSettingsToSave.isDenyDrivingHoursCalc = this.isDenyDrivingHoursCalc

      workShiftSettingsToSave.absent = this.absences

      workShiftSettingsToSave.overtimeBefore = this.overtimeBefore
      workShiftSettingsToSave.overtimeAfter = this.overtimeAfter

      if (!this.dayoff) {
        this.prepareWorkShiftToServer(workShiftSettingsToSave, this.selectWorkShift)
      } else {
        workShiftSettingsToSave.workShift = null
      }

      workShiftSettingsToSave.overtimeTariffComment = this.overtimeTariffComment
      workShiftSettingsToSave.overtimeTariffBeforeId = this.overtimeBefore && +this.overtimeBefore !== 0 ? this.overtimeTariffBeforeId : null
      workShiftSettingsToSave.overtimeTariffAfterId = this.overtimeAfter && +this.overtimeAfter !== 0 ? this.overtimeTariffAfterId : null

      if (!this.dayoff) {
        workShiftSettingsToSave.overtimeWorkShiftTariffId = this.isOvertimeWorkShift ? this.overtimeWorkShiftTariffId : null
      }

      if (this.workShiftSettings.isAdditional) {
        workShiftSettingsToSave.additionalOvertimeTariffId = this.additionalOvertimeTariffId
        delete workShiftSettingsToSave.comment
      }

      delete workShiftSettingsToSave.dismiss
      delete workShiftSettingsToSave.isDriverByDuration
      delete workShiftSettingsToSave.driverByDuration
      delete workShiftSettingsToSave.overtimeWorkShift
      delete workShiftSettingsToSave.dismissed
      delete workShiftSettingsToSave.redirectedWorkArea
      delete workShiftSettingsToSave.planDayStatus
      delete workShiftSettingsToSave.planDayHours
      delete workShiftSettingsToSave.factDayStatus
      delete workShiftSettingsToSave.factDayHours
      delete workShiftSettingsToSave.dayMatched
      delete workShiftSettingsToSave.workShiftDrivingHours
      delete workShiftSettingsToSave.overtimeDrivingHours
      delete workShiftSettingsToSave.drivingHours
      delete workShiftSettingsToSave.dayOvertimeTariffs
      delete workShiftSettingsToSave.overtime
    },
    prepareWorkShiftToServer: function (workShiftSettingsToSave, selectWorkShift) {
      workShiftSettingsToSave.workShift = selectWorkShift.key === 'brigadier.custom' ? null : selectWorkShift.key

      if (selectWorkShift.id) {
        workShiftSettingsToSave.id = selectWorkShift.id
      }

      if (selectWorkShift.key === 'brigadier.custom') {
        const start = new Date(selectWorkShift.start)
        const end = new Date(selectWorkShift.end)
        workShiftSettingsToSave.startHour = start.getHours()
        workShiftSettingsToSave.endHour = 24 * (end.getDate() - start.getDate()) + end.getHours()
        // workShiftSettingsToSave.actualStartWorkTime = selectWorkShift.start
        // workShiftSettingsToSave.actualEndWorkTime = selectWorkShift.end
      }

      delete workShiftSettingsToSave.key
      delete workShiftSettingsToSave.name
      delete workShiftSettingsToSave.actualStartWorkTime
      delete workShiftSettingsToSave.actualEndWorkTime

      return workShiftSettingsToSave
    },
    parseDate: function (value) {
      const pattern = /(\d{2})-(\d{2})-(\d{4})\s(\d{2}):(\d{2}):(\d{2})/
      return new Date(value.replace(pattern, '$3-$2-$1T$4:$5:$6'))
    },
    isAbsenceAllDay: function (absences, reason) {
      if (absences && absences.length == 1) {
        return (absences[0].reason == reason)
      } else {
        return false
      }
    },
    setAbsenceForAllDay: function (reason) {
      this.absences = []
      this.absences.push({
        startTime: null,
        endTime: null,
        reason: reason,
        anotherReason: null
      })
    },
    emitOvertimesChange: function () {
      this.$emit('update-overtimes', this.getOvertimesObject())
    },
    getOvertimesObject: function () {
      return {
        hasOvertime: !!this.overtimeTariffBeforeId || !!this.overtimeTariffAfterId,
        hasOvertimeWorkShift: !!this.overtimeWorkShiftTariffId
      }
    },
    onSelectAdditionalStatus: function () {
      if (this.workShiftSettings.isAdditional) {
        if (this.additionalStatus === 'workoff') {
          const workoffTariff = this.additionalOvertimeTariffsFiltered.find(tariff => tariff.value === 1)
          if (workoffTariff) {
            this.additionalOvertimeTariffId = workoffTariff.id
          }
        } else {
          const defaultTariff = this.additionalOvertimeTariffsFiltered.find(tariff => tariff.isDefault)
          if (defaultTariff) {
            this.additionalOvertimeTariffId = defaultTariff.id
          }
        }
      }
    },
    onSelectWorkShift: function (workShift) {
      this.selectWorkShift.key = workShift && workShift.key || null
      this.selectWorkShift.name = workShift && workShift.name || null
      this.selectWorkShift.startHour = workShift && workShift.startHour || null
      this.selectWorkShift.endHour = workShift && workShift.endHour || null
      this.selectWorkShift.start = workShift && workShift.start || null
      this.selectWorkShift.end = workShift && workShift.end || null
      this.selectWorkShift.date = this.workShiftSettings && this.workShiftSettings.date || null
    },
    onInputOvertimeWorkShift: function (value) {
      this.$refs.overtimeWorkShiftTariff.validate()
      if (!value) {
        this.overtimeWorkShiftTariffId = null
      } else {
        const defaultTariff = this.overtimeTariffsFiltered.find(tariff => tariff.isDefault)
        if (this.overtimeWorkShiftTariffId == null) {
          if (defaultTariff) {
            this.overtimeWorkShiftTariffId = defaultTariff.id
          }
        }
      }
    },
    onInputOvertimeWorkShiftTariff: function (value) {
      this.isOvertimeWorkShift = value != null
    }
  }
}

